import createValidationElementUtil from '../../../create-validation-element'
import { appMessages } from '../../../../../../messages'

function isEmail (value) {
  if (!value) {
    return false
  }

  const email = String(value).trim()

  if (email.length === 0) {
    return false
  }

  const pattern =
    /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/i

  return pattern.test(email)
}

function isEmailValidator (value) {
  const cyrillicPattern = /^[\u0400-\u04FF]+$/
  return value && isEmail(value) && !cyrillicPattern.test(value)
}

function emailValidatorUtil (value) {
  if (!isEmailValidator(value)) {
    return createValidationElementUtil(
      'email',
      appMessages.invalid,
      { name: 'Email' }
    )
  }
  return true
}

export default emailValidatorUtil
